const types = {
  // LISTAR
  LIST_COLABORADORES_REQUEST: "@colaborador/LIST_REQUEST",
  LIST_COLABORADORES_SUCCESS: "@colaborador/LIST_SUCCESS",
  LIST_COLABORADORES_FAILURE: "@colaborador/LIST_FAILURE",

  // CRIAR
  CREATE_COLABORADOR_REQUEST: "@colaborador/CREATE_REQUEST",
  CREATE_COLABORADOR_SUCCESS: "@colaborador/CREATE_SUCCESS",
  CREATE_COLABORADOR_FAILURE: "@colaborador/CREATE_FAILURE",

  // ATUALIZAR
  UPDATE_COLABORADOR_REQUEST: "@colaborador/UPDATE_REQUEST",
  UPDATE_COLABORADOR_SUCCESS: "@colaborador/UPDATE_SUCCESS",
  UPDATE_COLABORADOR_FAILURE: "@colaborador/UPDATE_FAILURE",

  // REMOVER
  UNLIKE_COLABORADOR_REQUEST: "@colaborador/UNLIKE_REQUEST",
  UNLIKE_COLABORADOR_SUCCESS: "@colaborador/UNLIKE_SUCCESS",
  UNLIKE_COLABORADOR_FAILURE: "@colaborador/UNLIKE_FAILURE",

  // SERVIÇOS
  LIST_SERVICOS_REQUEST: "@colaborador/SERVICOS_REQUEST",
  LIST_SERVICOS_SUCCESS: "@colaborador/SERVICOS_SUCCESS",
  LIST_SERVICOS_FAILURE: "@colaborador/SERVICOS_FAILURE",

  LOAD_SERVICOS_COLABORADOR_REQUEST: "@colaborador/LOAD_SERVICOS_COLABORADOR_REQUEST",
  LOAD_SERVICOS_COLABORADOR_SUCCESS: "@colaborador/LOAD_SERVICOS_COLABORADOR_SUCCESS",
  LOAD_SERVICOS_COLABORADOR_FAILURE: "@colaborador/LOAD_SERVICOS_COLABORADOR_FAILURE",

  /* FORM */
  UPDATE_FORM: "@colaborador/UPDATE_FORM",
  SET_FORM: "@colaborador/SET_FORM",
  RESET_FORM: "@colaborador/RESET_FORM",
  
};

export default types;
